import Selectable from './selectable';

export default Selectable.extend( {
	change: function( check, options = {} ) {
		// Abort if disabled
		if ( this.isDisabled ) {
			return this;
		}
		// Abort if changing to current value
		if ( this.isChecked === Boolean( check ) ) {
			return this;
		}

		return check ? this.check( options ) : this.uncheck( options );
	},

	check: function( options = {} ) {
		// Abort if disabled
		if ( this.isDisabled ) {
			return this;
		}

		var changed = ! this.isChecked;

		this.isChecked = true;

		if ( ! options.silent && changed ) {
			this.trigger( 'select' );
		}

		return this;
	},

	uncheck: function( options = {} ) {
		// Abort if disabled
		if ( this.isDisabled ) {
			return this;
		}

		var changed = this.isChecked;

		this.isChecked = false;

		if ( ! options.silent && changed ) {
			this.trigger( 'unselect' );
		}

		return this;
	},

	setDisabled: function( disabled ) {
		Selectable.prototype.setDisabled.apply( this, arguments );

		if ( disabled ) {
			this.uncheck();
		}
	},
} );
